<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import Fleet from './FleetDocument'
import Driver from './DriverDocument'
import { mapGetters } from 'vuex'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Lisensi',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Fleet,
    Driver,
  },
  data() {
    return {
      inPhase: true,
    }
  },
  computed: {
    title() {
      return this.$t('license.list.textTitle')
    },

    items() {
      return [
        {
          text: this.$t('setting.list.userSetting.setting'),
        },
        {
          text: this.$t('setting.list.userSetting.pengaturanPengguna'),
        },
      ]
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
      hasAccess: 'identity/hasAccess',
    }),
  },
  mounted() {
    this.$store.commit('license/SET_DOCTYPE', 'kendaraan')
  },
  methods: {
    toSave() {
      let updatedFleetDocs = this.$refs.fleet.form.vehicleDocs.filter(function (item) {
        return Object.hasOwn(item, 'oldExpired')
      }).length
      let updatedDriverDocs = this.$refs.driver.form.userDocs.filter(function (item) {
        return Object.hasOwn(item, 'oldExpired')
      }).length
      if (updatedFleetDocs > 0) {
        this.$refs.fleet.toSave()
      }
      if (updatedDriverDocs > 0) {
        this.$refs.driver.toSave()
      }
      if (updatedFleetDocs <= 0 && updatedDriverDocs <= 0) {
        return this.$mcToast.warning(this.$t('global.alert.text.noChanges'))
      }
    },

    toImport() {
      if (
        this.hasAccess('vehicle_docs:create') &&
        this.$store.state.license.docType == 'kendaraan'
      ) {
        this.$router.push({ name: 'License Fleet Import Fleet' })
      } else if (this.hasAccess('user_docs:create')) {
        this.$router.push({ name: 'License Fleet Import Driver' })
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">{{ $t('license.text.showLicense') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            v-if="!inPhase"
            variant="outline-primary"
            class="mc-ico"
            @click="$router.push({ name: 'License Setting' })"
          >
            <i class="icon-outline_settings"></i>
          </b-button>
          <b-button
            v-if="hasAccess('license_notification:read')"
            variant="outline-primary"
            type="button"
            class="ms-2"
            @click="$router.push({ name: 'License Reminder' })"
          >
            <i class="mc-fa icon-outline_calendar"></i> {{ $t('global.reminderDelivery') }}
          </b-button>
          <b-button variant="outline-primary" type="button" class="ms-2" @click="toImport">
            <i class="mc-fa icon-outline_upload"></i> {{ $t('global.action.upload') }}
          </b-button>

          <b-dropdown
            v-if="!inPhase"
            right
            variant="outline-primary"
            menu-class="dropdown-menu-end"
            class="ms-2"
          >
            <template v-slot:button-content>
              {{ $t('global.action.download') }} <i class="mdi mdi-chevron-down ps-2"></i>
            </template>
            <b-dropdown-item
              ><i class="bx bx-book-content align-middle pe-1"></i>
              {{ $t('global.action.downloadExcel') }}</b-dropdown-item
            >
            <b-dropdown-item
              ><i class="bx bx-book-content align-middle pe-1"></i>
              {{ $t('global.action.downloadPdf') }}</b-dropdown-item
            >
          </b-dropdown>

          <b-button
            v-if="hasAccess(['vehicle_docs:update', 'user_docs:update'])"
            variant="primary"
            type="button"
            class="ms-2"
            @click.prevent="toSave"
          >
            <i class="mc-fa icon-outline_save"></i> {{ this.$t('global.save') }}
          </b-button>
        </div>
      </div>
    </div>

    <form>
      <b-card class="mc-card__setting">
        <b-tabs content-class="p-3 text-muted" nav-wrapper-class="mc-tab">
          <Fleet v-if="hasAccess('vehicle_docs:read')" ref="fleet" docType="kendaraan" />
          <Driver v-if="hasAccess('user_docs:read')" ref="driver" docType="pengemudi" />
        </b-tabs>
      </b-card>
    </form>
  </Layout>
</template>
